import React from 'react';

export const SkipLink: React.FC = () => {
  return (
    <a href="#main-content" className="skip-link">
      Ugrás a tartalomhoz
    </a>
  );
};
